import { useEffect, useState } from 'react';
import { Home } from './pages/Home';
import { Game } from './pages/Game';
import { useSettings } from './hooks/useSettings';
import type { ClientSession } from './types';
import './styles.css';

const SESSION_KEY = 'crossword.session';

function readSession(): ClientSession | null {
  const raw = window.sessionStorage.getItem(SESSION_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as ClientSession;
  } catch {
    return null;
  }
}

export default function App() {
  const { settings, setSettings } = useSettings();
  const [session, setSession] = useState<ClientSession | null>(() => readSession());

  useEffect(() => {
    if (session) {
      window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
      window.history.replaceState(null, '', `/?game=${session.game_id}`);
    } else {
      window.sessionStorage.removeItem(SESSION_KEY);
    }
  }, [session]);

  return session ? (
    <Game session={session} onLeave={() => setSession(null)} />
  ) : (
    <Home settings={settings} onSettingsChange={setSettings} onSession={setSession} />
  );
}
